import { useState } from "react";
import { ArrowLeft } from "lucide-react";
import { Toaster } from "../components/ui/sonner";
import Logo from "../components/Logo";
import AdminLogin from "../components/admin/AdminLogin";
import EnquiryList from "../components/admin/EnquiryList";
import PhotoManager from "../components/admin/PhotoManager";

const TABS = [
  { id: "enquiries", label: "Enquiries" },
  { id: "photos", label: "Event Photos" },
];

export default function Admin() {
  const [authed, setAuthed] = useState(false);
  const [tab, setTab] = useState("enquiries");
  const [pending, setPending] = useState(0);

  if (!authed) return <AdminLogin onAuthed={() => setAuthed(true)} />;

  return (
    <div data-testid="admin-dashboard" className="min-h-screen bg-cream">
      <Toaster position="top-center" toastOptions={{ style: { background: "#0D0C0A", color: "#F5F1E8", border: "1px solid rgba(201,162,75,0.4)" } }} />
      <header className="border-b border-gold-faint bg-ivory/80 backdrop-blur-xl">
        <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-4 px-5 py-4 sm:px-8">
          <div className="flex items-center gap-3">
            <Logo className="h-9 w-9" />
            <div className="leading-tight">
              <h1 className="font-serif text-lg font-semibold">Admin</h1>
              <p className="text-[10px] uppercase tracking-[0.3em] text-gold-dark">Vayu Celebrations</p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            {TABS.map((t) => (
              <button
                key={t.id}
                data-testid={`admin-${t.id}-tab`}
                onClick={() => setTab(t.id)}
                className={`relative rounded-full px-5 py-2 text-[11px] font-semibold uppercase tracking-[0.2em] transition-colors ${
                  tab === t.id ? "bg-night text-gold" : "border border-gold-faint text-clay hover:text-gold-dark"
                }`}
              >
                {t.label}
                {t.id === "enquiries" && tab !== "enquiries" && pending > 0 && (
                  <span
                    data-testid="admin-enquiries-badge"
                    className="absolute -right-1.5 -top-1.5 flex h-5 min-w-5 items-center justify-center rounded-full bg-gold px-1 text-[10px] font-bold text-night"
                  >
                    {pending}
                  </span>
                )}
              </button>
            ))}
            <a
              data-testid="admin-back-to-site-link"
              href="/"
              className="flex items-center gap-2 rounded-full border border-gold-faint px-4 py-2 text-[11px] uppercase tracking-[0.2em] text-clay transition-colors hover:text-gold-dark"
            >
              <ArrowLeft className="h-3.5 w-3.5" /> Site
            </a>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-7xl px-5 py-10 sm:px-8">
        {tab === "enquiries" ? (
          <EnquiryList onUnauth={() => setAuthed(false)} onPending={setPending} />
        ) : (
          <PhotoManager onUnauth={() => setAuthed(false)} />
        )}
      </main>
    </div>
  );
}
